import type { ReactNode } from "react";
import { IconButton, Tooltip } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

interface DeleteButtonProps {
  deleteImage: () => void;
}

function DeleteButton({ deleteImage }: Readonly<DeleteButtonProps>): ReactNode {
  return (
    <IconButton
      aria-label="delete"
      onClick={(e) => {
        e.stopPropagation();
        deleteImage();
      }}
      sx={{ position: "absolute", top: 0, right: 0 }}>
      <Tooltip title="Supprimer">
        <CancelIcon color="error" sx={{ borderRadius: "100%", bgcolor: "white" }} />
      </Tooltip>
    </IconButton>
  );
}

export default DeleteButton;
